export const GET_ALL_GRADING = 'GET_ALL_GRADING';
export const GET_SPEC_DETAIL = 'GET_SPEC_DETAIL';
export const UNMOUNT_SPEC_TEMPLATE = 'UNMOUNT_SPEC_TEMPLATE';
export const GET_SPEC_LIBRARY_TEMPLATE = 'GET_SPEC_LIBRARY_TEMPLATE';
export const CLEAR_SPEC_REDUCER = 'CLEAR_SPEC_REDUCER';
export const GET_ALL_BRAND = 'GET_ALL_BRAND';
export const GET_CATEGORY_ONE_DATA = 'GET_CATEGORY_ONE_DATA';
export const GET_CATEGORY_TWO_DATA = 'GET_CATEGORY_TWO_DATA';
export const GET_CATEGORY_THREE_DATA = 'GET_CATEGORY_THREE_DATA';
export const GET_SPEC_DOCUMENT = 'GET_SPEC_DOCUMENT';
export const UPDATE_EXCEL_DATA = 'UPDATE_EXCEL_DATA';
export const GET_ALL_SPEC_TEMPLATE = 'GET_ALL_SPEC_TEMPLATE';
